import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getGradesHorarias = (params?: { turmaId?: number; unidadeId?: number }) => {
  const query = new URLSearchParams();
  if (params?.turmaId !== undefined) query.append("turmaId", String(params.turmaId));
  if (params?.unidadeId !== undefined) query.append("unidadeId", String(params.unidadeId));
  const qs = query.toString();
  const url = qs ? `${API_CONSTANT_MAP.gradeHoraria}?${qs}` : API_CONSTANT_MAP.gradeHoraria;
  return requestApi.get(url);
};

export const getGradeHorariaById = (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.gradeHoraria}/${id}`);
};

export const saveGradeHoraria = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.gradeHoraria, payload);
};
